import { render, staticRenderFns } from "./InHospitalDispensing.vue?vue&type=template&id=5bb327d6"
import script from "./InHospitalDispensing.vue?vue&type=script&lang=js"
export * from "./InHospitalDispensing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports